import React, { useEffect, useRef } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useTranslation } from "react-i18next"
import { useHistory, useLocation } from "react-router-dom"
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"
import clsx from "clsx"

import {
  printOrder,
  isDirectionLtr,
  getCheckoutPaymentInfo,
  clearCart,
  createPosPaymentRequest,
  posTerminalRequest
} from "utils"
import { Button } from "components"
import { sendOrder } from "services"
import { addNewShiftOrder } from "@redux"
import classes from "./KpAndroidPos.module.scss"

const KpAndroidPos = (props) => {
  const { setContent, setOrderLink, posTerminalDetails } = props

  const dispatch = useDispatch()

  const history = useHistory()

  const location = useLocation()

  const order =
    useSelector(state => state.order)

  const { cinemaSolonNumber, deliveryType } =
    useSelector(state => state.deliveryInfo)

  const userAccountInfo =
    useSelector(state => state.userAccountInfo)

  const shiftCashier =
    useSelector(state => state.shiftCashier)

  const [t, i18n] = useTranslation()

  const newShiftOrder = (shiftOrder) => {
    dispatch(addNewShiftOrder(shiftOrder))
  }

  const unmount = useRef(false)

  const handleGoBack = () => {
    history.push("/kiosk-checkout")
  }

  const getRequestBody = () => {
    const oItems =
      order.items.map(item => ({
        asComboSet: false,
        optionId: item.optionId,
        foodId: item.foodId,
        quantity: item.quantity,
        systemDiscount: item.systemDiscount * item.quantity,
        specificationItemIds:
          item.specificationItems.map(si => ({
            _id: si._id,
            quantity: si.quantity,
            builderStepKey: si.builderStepKey,
            portion: si.portion
          }))
      }))

    const cItems = []
    order.combos.forEach((combo, cIndex) =>
      combo.items.forEach(comboItem =>
        cItems.push({
          foodId: comboItem.foodId,
          optionId: comboItem.optionId,
          quantity: comboItem.quantity,
          specificationItemIds: [],
          comboSet: {
            code: combo.code,
            groupNumber: cIndex + 1,
            comboSetItemId: comboItem.comboSetItemId
          }
        })
      )
    )

    const items = [...cItems, ...oItems]

    const couponCodes = []

    const data = {
      items,
      isCod: false,
      isPrinted: true,
      deliveryType,
      branchId: userAccountInfo.branchId,
      couponCodes,
      customerMobilePhone: location.state?.customerMobilePhone || ""
    }

    const shiftId =
      shiftCashier[userAccountInfo._id]._id

    if (deliveryType === "dineIn") {
      data["tableNumber"] = "kiosk"
    }

    if (deliveryType === "cinema") {
      data["cinemaSolonNumber"] = cinemaSolonNumber
    }

    if (shiftId) {
      data["shiftId"] = shiftId
    }

    data["posTerminalName"] =
      posTerminalDetails.terminalName

    data["sendPrintCustomerReceiptToPos"] = true

    data["paymentType"] = "cash"

    data["cashType"] = cashType

    return data
  }

  const sendPcPosPaymentRequest = async () => {
    if (!posTerminalDetails) return

    try {
      const response =
        await posTerminalRequest.send(
          total,
          posTerminalDetails.terminalName,
          () => { },
          () => { }
        )

      if (unmount.current) return

      if (response === "canceled") throw new Error("Error")

      if (response === "unsuccess") {

        throw new Error("Error")
      }

      if (response === "requestFailed") {
        throw new Error("Error")
      }

      const posPaymentResult =
        await createPosPaymentRequest(total)

      if (!posPaymentResult) {
        throw new Error("Error")
      }

      if (unmount.current) return

      const body = getRequestBody()

      const { order } =
        await sendOrder(body)

      if (unmount.current) return

      const shiftOrder = {
        taxes: totalTax,
        charges: totalCharges,
        discounts: totalDiscount,
        cashTypes: cashType
      }

      setOrderLink(order._id)

      newShiftOrder(shiftOrder)

      printOrder(order)

      setContent("success")

      clearCart()
    } catch (err) {
      console.log(err)

      if (unmount.current) return

      setContent("fail")
    }
  }

  useEffect(() => {
    sendPcPosPaymentRequest()
  }, [])

  useEffect(() => {
    unmount.current = false

    return () => {
      unmount.current = true
    }
  }, [])

  const discounts = []

  const deliveryFees = null

  const {
    total,
    totalTax,
    totalCharges,
    totalDiscount,
  } = getCheckoutPaymentInfo(
    order.items,
    order.combos,
    discounts,
    deliveryFees,
    deliveryType
  )

  const cashType = [{
    type: posTerminalDetails.name,
    amount: total
  }]

  const isLtr =
    isDirectionLtr(i18n.language)

  return (
    <div className={classes["container"]}>
      <div className={classes["header"]}>
        <Button
          className={classes["button"]}
          onClick={handleGoBack}
        >
          {isLtr ? <FaChevronLeft /> : <FaChevronRight />}

          <span
            className={clsx(
              classes["text"],
              isLtr && classes["text-ltr"]
            )}
          >
            {t("بازگشت")}
          </span>
        </Button>
      </div>

      <div className={classes["wrapper"]}>
        <p className={classes["parag"]}>
          {t("لطفا_جهت_پرداخت_سفارشتان_از_دستگاه_کارت_خوان_استفاده_نمایید")}.
        </p>

        <img
          className={classes["image"]}
          src="/assets/images/checkout.png"
          alt=""
        />
      </div>
    </div>
  )
}

export default KpAndroidPos
